//import './bootstrap';
import Vue from 'vue'
import VueCal from 'vue-cal'

import 'materialize-css/dist/css/materialize.min.css'
import 'materialize-css/dist/js/materialize.min.js'
//import 'materialize-css/sass/materialize.scss'
import 'vue-cal/dist/vuecal.css'
import '../scss/app.scss'

// Importar tu componente
import Reservation from './components/Reservation.vue'
import ReservationForm from './components/ReservationForm.vue'

Vue.component('VueCal', VueCal)

Vue.component('reservation', Reservation)
Vue.component('reservation-form', ReservationForm)

new Vue({
  el: '#app',
})